import { FC, ReactNode } from 'react';
import { EyeIcon } from '@features/ui/icons';
import { EyeOff } from 'lucide-react';
import { Button } from '@features/ui';

interface ViewButtonProps {
  visible: boolean;
  onClick?: () => void;
  iconComponent?: ReactNode;
}
export const ViewButton: FC<ViewButtonProps> = ({
  visible,
  onClick,
  iconComponent,
}) => {
  return (
    <Button
      className="[&_svg]:!size-auto hover:text-white"
      variant={'ghost'}
      onClick={onClick}
    >
      {!visible ? (iconComponent ?? <EyeIcon />) : <EyeOff />}
    </Button>
  );
};
